import React from 'react';

const TunnelIcon = (props) => {
  return (
    <img
      alt="Tunel"
      src="/static/images/icons/place_types/tunnel.svg"
      {...props}
    />
  );
};

export default TunnelIcon;
